import { createTheme } from "@mui/material";

import { components } from "./components";
import { shadows } from "./tokens";
import { typography } from "./typography";

export const theme = createTheme({ typography, shadows, components });
